import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  PatientName: null,
  Gender: null,
  Dob: 0,
  IsHasNotDayDob: false,
  FromDate: 0,
  HeinCardNumber: null,
  LiveAreaCode: "",
  ToDate: null,
  BhytNumber: null,
  MediOrgCode: null,
  MediOrgName: null,
  FromTime: null,
  ToTime: null,
  Address: null,
  LiveCode: null,
  PeopleCode: null,

  card_code: null,
  first_name: null,
  hospital_id: null,
  hospital_name: null,
  patient_type_id: null,
  patient_type_name: null,
  province_id: null,
  province_name: null,
  register_date: null,
  room_id: null,
  room_name: null,
  service_id: null,
  service_name: null,
  offdays: null,
};

// dữ liệu form
model.dataFormStore = {
  PatientName: null,
  Gender: null,
  Dob: 0,
  IsHasNotDayDob: false,
  FromDate: 0,
  HeinCardNumber: null,
  LiveAreaCode: "",
  ToDate: null,
  BhytNumber: null,
  MediOrgCode: null,
  MediOrgName: null,
  FromTime: null,
  ToTime: null,
  Address: null,
  LiveCode: null,
  PeopleCode: null,

  card_code: null,
  first_name: null,
  hospital_id: null,
  hospital_name: null,
  patient_type_id: null,
  patient_type_name: null,
  province_id: null,
  province_name: null,
  register_date: null,
  room_id: null,
  room_name: null,
  service_id: null,
  service_name: null,
  offdays: null
};

// validation form
model.validForm = {
  PatientName: [ValidService.required],
  Gender: [ValidService.required],
  Dob: [ValidService.required],
  IsHasNotDayDob: [],
  FromDate: [],
  HeinCardNumber: [],
  LiveAreaCode: [],
  ToDate: [],
  BhytNumber: [],
  MediOrgCode: [],
  MediOrgName: [],
  FromTime: [],
  ToTime: [],
  Address: [],
  LiveCode: [],

  card_code: [ValidService.required],
  first_name: [ValidService.required],
  last_name: [ValidService.required],
  hospital_id: [ValidService.required],
  hospital_name: [ValidService.required],
  patient_type_id: [ValidService.required],
  patient_type_name: [ValidService.required],
  province_id: [ValidService.required],
  province_name: [ValidService.required],
  register_date: [ValidService.required],
  room_id: [],
  room_name: [],
  service_id: [ValidService.required],
  service_name: [ValidService.required],
  offdays: []
};

// dữ liệu mẫu các form khác
model.dataFormOther = {};

// validation các form khác
model.validFormOther = {};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100, 500],
  allowPaging: true,
  allowSorting: true,
  allowSelect: false,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "",
  defaultSort: ["register_date", "descending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {},
    valid: {},
    operator: {}
  }
};

export default model;
